/*******************************************************************************************
   _____            __              ____   ____                         .__               
  /  _  \   _______/  |________  ___\   \ /   /____   ____  __ __  _____|__|____    ____  
 /  /_\  \ /  ___/\   __\_  __ \/  _ \   Y   // __ \ /    \|  |  \/  ___/  \__  \  /    \ 
/    |    \\___ \  |  |  |  | \(  <_> )     /\  ___/|   |  \  |  /\___ \|  |/ __ \|   |  \
\____|__  /____  > |__|  |__|   \____/ \___/  \___  >___|  /____//____  >__(____  /___|  /
        \/     \/                                 \/     \/           \/        \/     \/ 
********************************************************************************************
Noop Fields
********************************************************************************************
https://github.com/final-form/final-form/issues/102#issuecomment-380408599

Author:     Nicholas Hamilton, PhD
Email:      nicholasehamilton@gmail.com
Date:       23rd December 2022

*******************************************************************************************/
import React        from 'react';
import { Field }    from 'react-final-form';

export const NoopFields = ({ names }) => (
    <React.Fragment>
        {names.map((name,ix) => <Field key={ix} name={name} render={() => {}} />)}
    </React.Fragment>
)

export default NoopFields;
